import React from 'react';
import { RadioGroup } from 'wix-style-react';
import { classes } from './BlackRadioGroup.st.css';

const BlackRadioGroup = (props: any) => {
  return <RadioGroup {...props} className={classes.root} />;
};

export default BlackRadioGroup;
